/* eslint-disable react/prop-types */
import { Box, Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import { style } from "./styles";

function GohonzonVerification({
  member,
  selectionHandler,
  selectedApplications,
}) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={style.Cell}>
        <Checkbox
          disabled={member.status === "BATCH_CREATED"}
          checked={selectedApplications.includes(member.id)}
          onChange={(e) => selectionHandler(e.target.checked, member.id)}
        />
      </TableCell>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.chapterName || "-"}</TableCell>
      <TableCell style={style.Cell}>{member.districtName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {member.appliedBy || "-"}
        <br />
        {/* {member.appliedAt !== null ? moment(member.appliedAt).format("L") : "-"} */}
        {member.appliedAt ? moment(member.appliedAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={style.tableCell}>
        <Box style={style.status}>{member.statusValue || "-"}</Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonVerification;
